const t=t=>"string"==typeof t;export{t as isString};
